<div class="m-1">
    <dx-select-box
        [(value)]="entityType"
        [items]="entityTypes"
        displayExpr="name"
        [searchEnabled]="true"
        (onValueChanged)="entityTypeValueChanged($event)"
        class="mt-3"
        width="250px"
    ></dx-select-box>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="entities">
        <dx-data-grid
            #dataGrid
            [dataSource]="entities"
            [columns]="gridColumns"
            keyExpr="id"
            [wordWrapEnabled]="true"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
        >
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" [storageKey]="`part-configurator-${entityType?.name}-grid`"></dxo-state-storing>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-row-dragging [allowReordering]="allowReorder" [onReorder]="onReorder" [showDragIcons]="false"></dxo-row-dragging>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <ng-container *ngIf="!entityType?.dataLocked">
                    <button class="btn btn-success" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="open(dataGrid.instance.getSelectedRowsData()[0])">
                        Open
                    </button>
                    <button class="btn btn-secondary ms-2" (click)="open()">New</button>
                    <button
                        *ngIf="allowDelete"
                        class="btn btn-danger ms-5"
                        (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Delete
                    </button>
                </ng-container>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="entities" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
